import styled from 'styled-components';
import { label } from 'styles/types';
import { screen, space } from 'styles/variables';

export const FooterContainer = styled.div<{ $embeddedAdmin?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ $embeddedAdmin }) =>
    ($embeddedAdmin ? `${space.x2} 30px` : `${space.x2} 0`)};
  width: ${({ $embeddedAdmin }) =>
    ($embeddedAdmin ? 'calc(100% - 60px)' : '100%')};

  @media (min-width: ${screen.smMin}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${screen.smMin}) {
    flex-direction: row;
  }
`;

export const Link = styled.a`
  font: ${label.reg.x12};
  margin: 0 0 ${space.x3};
  text-decoration: none;

  &:last-child {
    margin: 0;
  }

  @media (min-width: ${screen.smMin}) {
    margin: 0 ${space.x3} 0 0;
  }
`;
